import { useCallback, useState } from "react";
import { useReportApi, unwrapReport } from "../api/reportApi";

// #846 — Score Admin's per-ride "Resend score sheet" button. Calls report-api's
// authed POST /score-sheets/rides/:rideId/resend, which reuses the SAME
// create-or-reuse/cooldown/notify flow the public rider portal (#621/#630) and
// #822's auto-on-Place fan-out already share (report-api's
// lib/rider-sheet-flow.js) — this is a third trigger onto that one flow, not a
// new send path. `email` is optional; report-api defaults to the rider's
// on-file address when omitted, and never persists an override onto the
// rider's own record either way.
export function useResendScoreSheet() {
  const reportApi = useReportApi();
  const [sending, setSending] = useState(false);

  const resend = useCallback(
    async (rideId, email) => {
      setSending(true);
      try {
        const res = await reportApi.riderSheets.resendScoreSheet(
          rideId,
          email ? { email } : {},
        );
        return unwrapReport(res);
      } finally {
        setSending(false);
      }
    },
    [reportApi],
  );

  return { resend, sending };
}

export default useResendScoreSheet;
